import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import NavBtn from '../../Components/NavBtn';
import StepCounter from '../../Components/StepCounter';
import FormBeneficiario from '../../Components/FormBeneficiario';
import LoadingB from '../../Components/LoadingBeneficiario';
import Header from '../../Components/Header';

import {
	addSubscription,
	newRemoveSubscription,
	newEditSubscription
} from '../../_redux/actions/subscription';

import { setUpdateOrder } from '../../_redux/actions/order';
import { createOrder } from '../../_redux/actions/order';
import { addPayer } from '../../_redux/actions/payer';
import { userLogin } from '../../_redux/actions/auth';
import {
	FaRegEdit,
	FaTimesCircle,
	FaCheckCircle,
	FaThumbsUp,
	FaTrashAlt
} from 'react-icons/fa';

import { waitSubscription } from '../../_redux/actions/subscription';
import {
	setWaitCampaign,
	applyCampaign,
	applyCampaignInfo
} from '../../_redux/actions/campaign';
import { verifySignatureChosen } from '../../_redux/actions/signatureChosen';
import { verifyTokenCmDrConsulta } from '../../_redux/actions/cmDrConsulta';

import { getPlanList } from '../../_redux/actions/plan';

import { formUtils, campaignUtils, originUtils } from '../../utils';

import { hotjar } from 'react-hotjar';
import { PageView, initGA } from '../../Components/Tracking';
import { ThemeProvider } from 'styled-components';
import ThemeSelector from '../../style/themes/ThemeSelector';
import TitleListSubscribers from '../../style/styledComponents/TtleListSubscribers';
import ListSubscribers from '../../style/styledComponents/ListSubscribers';
import FormButton from '../../style/styledComponents/FormButton';
import FormWrapper from '../../style/styledComponents/FormWrapper';

import BoxSize from '../../style/styledComponents/BoxSize';

import stores from '../../utils/stores';
import Container from '../../style/styledComponents/Container';
import cmDrConsulta from '../../_redux/actions/api/cmDrConsulta';
import { string } from 'prop-types';
class Beneficiario extends Component {
	constructor() {
		super();

		this.formData = this.formData.bind(this);
		this.formSend = this.formSend.bind(this);
		this.errorAccept = this.errorAccept.bind(this);
		this.handleRemove = this.handleRemove.bind(this);
		this.handleAdd = this.handleAdd.bind(this);
		this.handleEdit = this.handleEdit.bind(this);
		this.handleStartEdit = this.handleStartEdit.bind(this);
		this.checkErrorOnField = this.checkErrorOnField.bind(this);
		this.checkIfIncomplete = this.checkIfIncomplete.bind(this);
		this.payerErrorAccept = this.payerErrorAccept.bind(this);
		this.handleIsComplete = this.handleIsComplete.bind(this);
		this.continueWithoutDependent = this.continueWithoutDependent.bind(this);
		this.fieldsTouched = false;
		this.addMoreSubscribers = this.addMoreSubscribers.bind(this);

		this.state = {
			error: null,
			loja: null,
			editData: {},
			isEdit: false,
			editSubscriptionId: null,
			cleanForm: false,
			skipAddressForm: false,
			confirmRemove: false,
			subscriptionToBeRemoved: null,
			isLoading: false,
			isNextDisabled: true,
			isIncomplete: false,
			errorOnField: [],
			incompleteUser: {},
			completeButNotSaved: false,
			isComplete: false,
			isEpay: false,
			isVivo: false,
			isCmDrConsulta: false,
			showForm: true,
			isSignatureChosen: false,
			isLevelled: false,
			errorSubscription: {}
		};
	}

	componentWillMount() {}

	async componentDidMount() {
		const planType = campaignUtils.getPlanType(this.props.location.search);
		const {
			GiftCode,
			VivoUser,
			Order,
			CmDrConsulta,
			SignatureChosen,
			Levelled
		} = this.props;
		const giftCodeData = GiftCode.data;
		const vivoUser = VivoUser.data;
		const cmDrConsulta = CmDrConsulta.data;
		const signatureChosen = SignatureChosen.data;
		const levelled = Levelled.data;

		let { loja } = this.props.match.params;

		if (this.props.location.isEditting) {
			this.handleStartEdit(
				this.props.location.isEditting.userToBeEditted,
				this.props.location.isEditting.userToBeEditted?.position
			);
			this.setState({ skipAddressForm: true });
		}

		if (this.props.location.skipFormAddress) {
			this.setState({ skipAddressForm: true });
		}

		if (this.props.Subscription.data.itens.length > 0) {
			this.setState({ isNextDisabled: false });
		}
		sessionStorage.setItem('planType', planType);

		initGA();
		PageView(`/loja/${loja}/beneficiario`);

		hotjar.initialize(937897, 6);

		if (loja !== 'epay' && loja !== 'vivoavulso' && loja !== 'levelled') {
			await this.props.getPlanList(loja);
		}

		const searchParams = new URLSearchParams(this.props.location.search);
		const utmSource = searchParams.get('utm_source');

		if (utmSource === 'coop' && this.props.Subscription.data.itens.length > 0) {
			const subscription = this.props.Subscription.data.itens[0];
			const key = 0;
			this.handleStartEdit(subscription, key);
		}

		if (Object.keys(signatureChosen).length > 0) {
			this.setState({
				isSignatureChosen: true
			});
		} else if (
			loja === 'qualicorp' ||
			loja === 'yalo' ||
			loja === 'familia' ||
			loja === 'drconsulta' ||
			loja === 'valesaude' ||
			loja === 'ifood' ||
			loja === 'allya'
		) {
			this.setState({ isSignatureChosen: true });
			sessionStorage.setItem('store', stores.qualicorp);
			const Plan = this.props.Plan.list;
			const signatureTypeAndPlanId = campaignUtils.getSignatureTypeAndPlanId(
				this.props.location.search
			);
			let signaturePlan = '';

			signaturePlan = Plan.filter(
				plan =>
					//plan.signature_type === signatureTypeAndPlanId.assinatura &&
					plan.planId === signatureTypeAndPlanId.code
			);

			this.props.verifySignatureChosen(signaturePlan);
			const erro = this.props.SignatureChosen.data.hasError;
			const dependentIsActive = new URLSearchParams(window.location.search).get('utm_source') === 'coop' ? false : this.props.SignatureChosen.data.active_dependents;

			sessionStorage.setItem('dependentIsActive', dependentIsActive);

			if (loja === 'qualicorp') {
				if (dependentIsActive == true) {
					sessionStorage.setItem('store', stores.qualiFamilia);
				} else if (signatureTypeAndPlanId.assinatura === 'mais') {
					sessionStorage.setItem('store', stores.qualiMais);
				}

				if (erro && dependentIsActive == true) {
					alert('OPS! Assinatura não encontrada.');
					window.location =
						'/loja/qualicorp/beneficiario?assinatura=familia&code=106';
				} else if (erro && signatureTypeAndPlanId.assinatura === 'mais') {
					alert('OPS! Assinatura não encontrada.');
					window.location =
						'/loja/qualicorp/beneficiario?assinatura=mais&code=93';
				}
			} else if (loja === 'yalo' || loja === 'familia') {
				if (erro) {
					alert('OPS! Assinatura não encontrada.');
					window.location = '/loja/';
				}
			} else if (loja === 'drconsulta') {
				if (erro) {
					alert('OPS! Assinatura não encontrada.');
					this.props.history.goBack();
				}
				if (signatureTypeAndPlanId.code === '108') {
					sessionStorage.setItem('store', stores.drConsultaDrc);
				} else if (signatureTypeAndPlanId.code === '109') {
					sessionStorage.setItem('store', stores.drConsultaExame);
				} else if (signatureTypeAndPlanId.code === '110') {
					sessionStorage.setItem('store', stores.drConcultaTelemedicina);
				}
			}
		}

		if (Object.keys(cmDrConsulta).length > 0) {
			this.setState({ isCmDrConsulta: true });
		} else if (loja === 'cmdrconsulta') {
			this.setState({ isCmDrConsulta: true });

			const Plan = this.props.Plan.list;
			const signatureTypeAndPlanId = campaignUtils.getSignatureTypeAndPlanId(
				this.props.location.search
			);
			let signaturePlan = '';

			signaturePlan = Plan.filter(
				plan =>
					//plan.signature_type === signatureTypeAndPlanId.assinatura &&
					plan.planId === signatureTypeAndPlanId.code
			);

			this.props.verifyTokenCmDrConsulta(signaturePlan);

			const dependentIsActive = this.props.CmDrConsulta.data.active_dependents;
			sessionStorage.setItem('dependentIsActive', dependentIsActive);

			const erro = this.props.CmDrConsulta.data.hasError;
			if (erro) {
				alert('OPS! Assinatura não encontrada.');
				window.location = 'https://yalo.com.br/cmdrconsulta/';
			}
		}

		if (window.jQuery) {
			let $ = window.jQuery;
			$(document).ready(function() {
				$(this).scrollTop(0);
			});
		}
		let { Subscription } = this.props;
		let subscriptionList = Subscription.data.itens;

		if (Object.keys(levelled).length > 0) {
			this.setState({ isLevelled: true });

			const dependentIsActive = this.props.Levelled.data.active_dependents;
			sessionStorage.setItem('dependentIsActive', dependentIsActive);

			if (subscriptionList.length > 0) {
				this.handleStartEdit(subscriptionList[0]);
			}
		} else if (Object.keys(giftCodeData).length > 0) {
			this.setState({ isEpay: true });

			if (subscriptionList.length > 0) {
				this.handleStartEdit(subscriptionList[0]);
			}
		} else if (Object.keys(vivoUser).length > 0) {
			this.setState({ isVivo: true });
			if (subscriptionList.length > 0) {
				this.handleStartEdit(subscriptionList[0]);
			}
		}

		if (subscriptionList.length > 0) {
			this.setState({ isComplete: true });
		}

		const dependentIsActive = sessionStorage.getItem('dependentIsActive');

		if (dependentIsActive == true) {
			if (
				subscriptionList.length ===
					Number(signatureChosen.number_of_dependents) + 1 ||
				subscriptionList.length ===
					Number(cmDrConsulta.number_of_dependents) + 1 ||
				subscriptionList.length === Number(levelled.number_of_dependents) + 1
			) {
				this.setState({ showForm: false });
				//verifica se já possui um orderId e a familia não ta cheia ou
				// ele ta sendo editado, caso sim ele renderiza o form e ativa o butão de
				//adicionar depentente
				//Obs só tem efeito pro plano familia
				if (Order.value.orderId || this.props.location.isEditting) {
					if (
						subscriptionList.length <
							Number(signatureChosen.number_of_dependents) + 1 ||
						subscriptionList.length <
							Number(cmDrConsulta.number_of_dependents) + 1 ||
						subscriptionList.length <
							Number(levelled.number_of_dependents) + 1 ||
						this.props.location.isEditting
					) {
						this.setState({ showForm: true });
					}
				}
			}
		}

		this.handleIsComplete();
	}

	componentDidUpdate(prevProps) {
		if (this.props.Plan !== prevProps.Plan) {
			//const planType = campaignUtils.getPlanType(this.props.location.search);
			const {
				Plan: { list }
			} = this.props;
			let hasUsedCard = list.some(plan => plan.used_card === '1');
			// prettier-ignore
			if (!this.props.location.isEditting && !this.props.location.skipFormAddress) {
				this.setState({ skipAddressForm: !hasUsedCard });
			}
		}

		if (
			prevProps.Subscription.data.error &&
			prevProps.Subscription.data.error !== this.props.Subscription.data.error
		) {
			this.setState({ errorSubscription: this.props.Subscription.data.error });
		}

	}

	formData(data) {
		this.data = data;
	}

	handleStartRemove(subscription) {
		this.setState({
			confirmRemove: true,
			subscriptionToBeRemoved: subscription,
			showForm: true
		});
	}

	handleRemove(subscription) {
		this.props.newRemoveSubscription(subscription.subscriptionId);

		this.setState({
			subscriptionToBeRemoved: null,
			confirmRemove: false
		});
	}

	handleStartEdit(data, position) {
		data.addressId = '';
		const editData = data;
		editData.checkedWhatsapp =
			data.accepted_whatsapp == 1
				? true
				: data.accepted_whatsapp === null
				? null
				: false;
		editData.checkedEmail =
			data.accepted_email == 1
				? true
				: data.accepted_email === null
				? null
				: false;
		editData.position = position;

		this.setState({
			cleanForm: false,
			editData,
			isEdit: true,
			editSubscriptionId: data.subscriptionId,
			isComplete: false,
			showForm: true,
			position: position
		});
	}

	async handleEdit() {
		const { Order, SignatureChosen, CmDrConsulta, Levelled } = this.props;
		const signatureChosen = SignatureChosen.data;
		const cmDrConsulta = CmDrConsulta.data;
		const levelled = Levelled.data;
		const dependentIsActive = sessionStorage.getItem('dependentIsActive');
		let { loja } = this.props.match.params;
		let isEditing = campaignUtils.getEdit(this.props.location.search);
		let addressId = isEditing ? isEditing : null;
		let { Subscription } = this.props;
		let subscriptionList = Subscription.data.itens;
		this.setState({ isLoading: true });
		const formData = formUtils.formatData(this.data);
		const orderId = Order.data.orderId;
		const subId = this.state.editSubscriptionId;
		const data = { ...formData, subscriptionId: subId, orderId };
		let checkDataValue = formUtils.checkData(this.data);

		if (checkDataValue) {
			this.setState({
				error: checkDataValue
			});
			return;
		}

		if (this.data.cpf.value) {
			var newCpf = this.data.cpf.value;
		}
		if (Subscription.data.itens) {
			const cpfAlreadyExists = Subscription.data.itens.find(
				sub => sub.subscriptionId !== subId && sub.cpf === newCpf
			);
			if (cpfAlreadyExists) {
				this.setState({
					error: 'CPF já está na lista de assinantes!',
					isLoading: false
				});
				return { success: false };
			}
		}

		data.lengthOfSubscriptions = Subscription.data.itens.length;
		await this.props.newEditSubscription(data);

		if (this.state.errorSubscription.statusCode === 403) {
			this.setState({
				error: this.state.errorSubscription.content.error,
				isLoading: false
			});

			return { success: false };
		}

		const searchParams = new URLSearchParams(this.props.location.search);
    	const utmSource = searchParams.get('utm_source');
		if (
			loja === 'epay' ||
			loja === 'vivoavulso' ||
			loja === 'levelled' ||
			addressId ||
			utmSource === 'coop'
		) {
			this.formSend();
		}


		if (dependentIsActive == true) {
			if (
				subscriptionList.length ===
					Number(signatureChosen.number_of_dependents) + 1 ||
				subscriptionList.length ===
					Number(cmDrConsulta.number_of_dependents) + 1 ||
				subscriptionList.length === Number(levelled.number_of_dependents) + 1
			) {
				this.setState({ showForm: false });
			}
		}
		this.setState({
			isEdit: false,
			cleanForm: true,
			isComplete: true,
			isLoading: false
			//showForm: false
		});
	}

	checkErrorOnField() {
		let checkDataValue = formUtils.checkAllErrors(this.data);
		this.setState({ errorOnField: checkDataValue });
	}

	async handleAdd() {
		this.fieldsTouched = false;
		const signatureType = campaignUtils.getPlanType(this.props.location.search);
		const dependentIsActive = sessionStorage.getItem('dependentIsActive');

		let yaloProm = null;
		if (campaignUtils.checkExistInStorage(this.props.location.search)) {
			let campaignData = campaignUtils.getData();
			this.props.setWaitCampaign(campaignData);
			yaloProm = campaignData.prom;
		}
		this.checkErrorOnField();
		this.setState({ cleanForm: false, isLoading: true });
		let { Subscription, SignatureChosen, CmDrConsulta, Levelled } = this.props;
		const signatureChosen = SignatureChosen.data;
		const levelled = Levelled.data;
		const cmDrConsulta = CmDrConsulta.data;

		let { loja: storeIdentifier } = this.props.match.params;
		const isEditing = campaignUtils.getEdit(this.props.location.search);
		const planId = campaignUtils.getPlan(this.props.location.search);

		let addressId = isEditing ? isEditing : null;
		const subscriptionList = Subscription.data.itens;
		const data = formUtils.formatData(this.data);

		let checkDataValue = formUtils.checkData(this.data);
		if (checkDataValue) {
			this.setState({
				// error: checkDataValue,
				isLoading: false
			});
			this.fieldsTouched = true;
			return { success: false };
		}

		if (subscriptionList.length === 0) {
			let error = await this.props.addPayer(data);

			this.setState({ payerError: error });

			await this.props.userLogin(data.email, '');

			const signatureType = campaignUtils.getPlanType(
				this.props.location.search
			);
			let planId = null;
			let {
				Payer,
				GiftCode,
				VivoUser,
				CmDrConsulta,
				SignatureChosen,
				DrConsulta,
				Levelled
			} = this.props;

			if (this.state.isEpay) {
				planId = GiftCode.data.plan.id;
			} else if (this.state.isVivo) {
				planId = VivoUser.data.ecommerce_plan_id.toString();
			} else if (this.state.isCmDrConsulta) {
				planId = CmDrConsulta.data.planId;
			} else if (this.state.isSignatureChosen) {
				planId = SignatureChosen.data.planId;
			} else if (this.state.isDrConsuta) {
				planId = DrConsulta.data.planId;
			} else if (this.state.isLevelled) {
				planId = Levelled.data.plan.id;
			}

			if (Payer.data.statusCode) {
				this.setState({
					error: 'Já existe um cadastro com esse e-mail',
					isLoading: false
				});

				return { success: false };
			}

			const trackingUtm = {
				utmContent: campaignUtils.campaignData?.utmContent,
				utmTerm: campaignUtils.campaignData?.utmTerm,
				utmMedium: campaignUtils.campaignData?.utmMedium,
				utmSource: campaignUtils.campaignData?.utmSource,
				utmCampaign: campaignUtils.campaignData?.utmCampaign
			};
			await this.props.createOrder(
				Payer.data.payerId,
				//null,
				addressId,
				storeIdentifier,
				signatureType,
				planId,
				trackingUtm
			);
		} else {
			if (this.data.cpf.value) {
				var newCpf = this.data.cpf.value;
			}
			if (Subscription.data.itens) {
				const cpfAlreadyExists = Subscription.data.itens.find(
					sub => sub.cpf === newCpf
				);
				if (cpfAlreadyExists) {
					this.setState({
						error: 'CPF já está na lista de assinantes!',
						isLoading: false
					});
					return { success: false };
				}
			}
		}

		let { Campaign, Order } = this.props;
		if (planId) {
			this.props.setUpdateOrder(planId, Order.data.orderId);
		}
		data.lengthOfSubscriptions = Subscription.data.itens.length;
		if (dependentIsActive == true && subscriptionList.length >= 1) {
			const subscriptionParentId = subscriptionList[0].subscriptionId;

			await this.props.addSubscription(
				Order.data.orderId,
				null,
				data,
				subscriptionParentId
			);
		} else {
			await this.props.addSubscription(Order.data.orderId, null, data);
		}

		if (this.state.errorSubscription.statusCode === 403) {
			this.setState({
				error: this.state.errorSubscription.content.error,
				isLoading: false
			});

			return { success: false };
		}

		this.setState({
			cleanForm: true,
			isLoading: false,
			isNextDisabled: false
		});

		if (Order.data.orderId && Campaign.wait.utmCampaign) {
			await this.props.applyCampaign(
				Order.data.orderId,
				Campaign.wait.utmCampaign,
				yaloProm,
				originUtils.getOrigin()
			);
			await this.props.applyCampaignInfo(Campaign.wait);
		}

		if (dependentIsActive == true) {
			if (
				subscriptionList.length ===
					Number(signatureChosen.number_of_dependents) ||
				subscriptionList.length === Number(cmDrConsulta.number_of_dependents) ||
				subscriptionList.length === Number(levelled.number_of_dependents)
			) {
				this.setState({ showForm: false });
			}
		}
		return { success: true };
	}

	async checkIfIncomplete(addPayerSuccess) {
		const formData = formUtils.formatData(this.data);
		let isIncomplete = false;

		for (let field in formData) {
			if (formData.name) {
				if (
					!formData[field] &&
					field !== 'checkedWhatsapp' &&
					field !== 'checkedEmail'
				) {
					isIncomplete = true;
				}
			}
		}
		if (!isIncomplete) {
			if (formData.name) {
				const res = !addPayerSuccess
					? { success: false }
					: await this.handleAdd();
				if (res.success) {
					this.formSend();
				}
				return;
			}
		}
		let { Subscription } = this.props;
		const subscriptionList = Subscription.data.itens;
		if (subscriptionList.length < 1) {
			this.setState({
				error: 'É necessário adicionar um assinante!'
			});
			return;
		}

		if (isIncomplete) {
			this.setState({
				isIncomplete: true,
				cleanForm: false,
				incompleteUser: formData
			});
			this.fieldsTouched = true;
			return;
		}
		this.formSend();
	}

	async formSend() {
		let { Order } = this.props;
		let { loja } = this.props.match.params;

		if (this.state.payerError) {
			this.fieldsTouched = true;
			return;
		} else {
			const nextPage =
				Order.value.orderId === Order.data.orderId
					? 'pagamento'
					: this.state.skipAddressForm
					? this.state.isEpay ||
					  this.state.isVivo ||
					  this.state.isCmDrConsulta ||
					  this.state.isSignatureChosen ||
					  this.state.isDrConsuta ||
					  this.state.isLevelled
						? 'pagamento'
						: 'carrinho'
					: 'enderecoBeneficiario';

			this.props.history.push(process.env.PUBLIC_URL + `/${loja}/${nextPage}`);
		}
	}

	errorAccept() {
		this.setState({
			error: null
		});
	}
	payerErrorAccept() {
		this.setState({
			payerError: null
		});
	}

	handleIsComplete() {
		this.setState({
			cleanForm: false
		});
		let { Subscription } = this.props;
		let subscriptionList = Subscription.data.itens;
		let formData = formUtils.formatData(this.data);
		let isIncomplete = false;
		for (let field in formData) {
			if (formData[field] === undefined) {
				isIncomplete = true;
			}
		}

		if (subscriptionList.length > 0) {
			this.setState({ isComplete: true });
		} else {
			if (isIncomplete) {
				this.setState({
					isComplete: false
				});
			} else {
				this.setState({
					isComplete: true
				});
			}
		}
	}
	async continueWithoutDependent() {
		const { loja } = this.props.match.params;
		let { Subscription } = this.props;
		const subscriptionList = Subscription.data.itens;
		const { SignatureChosen, CmDrConsulta, Levelled } = this.props;
		const signatureChosen = SignatureChosen.data;
		const cmDrConsulta = CmDrConsulta.data;
		const levelled = Levelled.data;

		// Verificar se utm_source=coop
		const searchParams = new URLSearchParams(this.props.location.search);
		const utmSource = searchParams.get('utm_source');

		let result = null;
		if (subscriptionList.length >= 0) {
			result = await this.handleAdd();
			if (result.success) {
				if (
					subscriptionList.length < signatureChosen.number_of_dependents ||
					subscriptionList.length < cmDrConsulta.number_of_dependents ||
					subscriptionList.length < levelled.number_of_dependents
				) {
					// Se for coop, pular para a próxima tela como se o botão NÃO fosse clicado
					if (utmSource === 'coop') {
						this.formSend();  // Chama diretamente a função que continua para a próxima página
						return;
					}

					this.setState({ holderWithoutDependent: true });
				} else {
					this.checkIfIncomplete(true);
				}
			} else {
				this.checkIfIncomplete(result?.success);
			}
		}
	}
	async addMoreSubscribers() {
		const { loja } = this.props.match.params;
		let { Subscription } = this.props;
		const subscriptionList = Subscription.data.itens;
		let result = null;
		if (subscriptionList.length >= 0) {
			result = await this.handleAdd();
			if (
				result.success &&
				loja != 'epay' &&
				loja != 'vivoavulso' &&
				loja != 'levelled'
			) {
				this.setState({ singleSubscriber: true });
			} else {
				this.checkIfIncomplete(true);
			}
		}
	}
	render() {
		const { SignatureChosen, CmDrConsulta, Levelled } = this.props;
		const signatureChosen = SignatureChosen.data;
		const cmDrConsulta = CmDrConsulta.data;
		const levelled = Levelled.data;
		let { Subscription } = this.props;
		let editFormData = this.state.editData;
		const subscriptionList = Subscription.data.itens;
		const { loja } = this.props.match.params;
		const signatureType = campaignUtils.getPlanType(this.props.location.search);
		const dependentIsActive = sessionStorage.getItem('dependentIsActive');

		let removeConfirmation = '';
		if (this.state.confirmRemove) {
			removeConfirmation = (
				<div className='overlay'>
					<div className='overlay-box'>
						<div className='overlay-box--content'>
							<p>
								{' '}
								Você gostaria de remover{' '}
								{this.state.subscriptionToBeRemoved.name}?{' '}
							</p>
						</div>

						<div className='overlay-button'>
							<button
								className='overlay-box--close f-bold btn-yes'
								onClick={() =>
									this.handleRemove(this.state.subscriptionToBeRemoved)
								}>
								<FaCheckCircle size={20} /> Sim
							</button>
							<p> </p>
							<button
								className='overlay-box--close f-bold btn-not'
								onClick={() => this.setState({ confirmRemove: false })}>
								<FaTimesCircle size={20} /> {' 	'} Não
							</button>
						</div>
					</div>
				</div>
			);
		}
		let payerError = '';
		if (this.state.payerError) {
			payerError = (
				<div className='overlay'>
					<div className='overlay-box'>
						<div className='overlay-box--content'>
							<p>
								{' '}
								Ocorreu um erro ao realizar seu cadastro, por favor entre em
								contato com a nossa equipe através dos telefones: 4004-1664 para
								capitais e regiões metropolitanas e 4000-1664 para outras
								regiões{' '}
							</p>
						</div>
						<div className='overlay-button'>
							<button
								className='overlay-box--close f-bold btn-ok'
								onClick={this.payerErrorAccept}>
								<FaThumbsUp size={18} /> Ok
							</button>
						</div>
					</div>
				</div>
			);
		}
		let isIncompleteConfirmation = '';
		if (this.state.isIncomplete) {
			isIncompleteConfirmation = (
				<div className='overlay'>
					<div className='overlay-box'>
						<div className='overlay-box--content'>
							{this.state.isEdit ? (
								<p>
									Os dados do assinante {this.state.incompleteUser.name} estão
									sendo alterados
									<br /> Deseja seguir sem alteração?
								</p>
							) : this.state.completeButNotSaved ? (
								<p>
									Os dados do assinante {this.state.incompleteUser.name} não
									foram adicionados.
									<br /> Deseja seguir sem ele?
								</p>
							) : (
								<p>
									Os dados do assinante {this.state.incompleteUser.name} estão
									incompletos.
									<br />
									Deseja seguir sem ele?
								</p>
							)}
						</div>
						<FormButton className='overlay-button'>
							<button
								className='overlay-box--close f-bold btn-border-color-yes'
								onClick={() => this.formSend()}>
								<FaCheckCircle size={20} /> Sim
							</button>

							<button
								className='overlay-box--close f-bold btn-border-color-not'
								onClick={() => this.setState({ isIncomplete: false })}>
								<FaTimesCircle size={20} /> Não
							</button>
						</FormButton>
					</div>
				</div>
			);
		}

		let moveForwardWithoutDependents = '';
		if (this.state.holderWithoutDependent) {

			if (new URLSearchParams(window.location.search).get('utm_source') === 'coop') {
				this.formSend();
			}else{

				moveForwardWithoutDependents = (
					<div className='overlay'>
						<div className='overlay-box'>
							<div className='overlay-box--content'>
								{this.state.completeButNotSaved ? (
									<p>
										Os dados do assinante {this.state.incompleteUser.name} não
										foram adicionados.
										<br /> Deseja seguir sem ele?
									</p>
								) : (
									<p>Vamos adicionar dependentes?</p>
								)}
							</div>
							<FormButton className='overlay-button'>
								<button
									className='overlay-box--close f-bold btn-border-color-yes'
									onClick={() =>
										this.setState({ holderWithoutDependent: false })
									}>
									<FaCheckCircle size={20} /> Sim
								</button>

								<button
									className='overlay-box--close f-bold btn-border-color-not'
									onClick={() => this.formSend()}>
									<FaTimesCircle size={20} /> Não
								</button>
							</FormButton>
						</div>
					</div>
				);
			}
		}

		let advanceWithoutSubscribers = '';
		if (this.state.singleSubscriber) {

			if (new URLSearchParams(window.location.search).get('utm_source') === 'coop') {
				this.formSend();
			}else{

				advanceWithoutSubscribers = (
					<div className='overlay'>
						<div className='overlay-box'>
							<div className='overlay-box--content'>
								{this.state.completeButNotSaved ? (
									<p>
										Os dados do assinante {this.state.incompleteUser.name} não
										foram adicionados.
										<br /> Deseja seguir sem ele?
									</p>
								) : (
									<p>Vamos adicionar mais assinantes?</p>
								)}
							</div>
							<div className='overlay-button'>
								<button
									className='overlay-box--close f-bold btn-yes'
									onClick={() => this.setState({ singleSubscriber: false })}>
									<FaCheckCircle size={20} /> Sim
								</button>

								<button
									className='overlay-box--close f-bold btn-not'
									onClick={() => this.formSend()}>
									<FaTimesCircle size={20} /> Não
								</button>
							</div>
						</div>
					</div>
				);
			}
		}

		let listFamily = '';
		const searchParams = new URLSearchParams(this.props.location.search);
		const utmSource = searchParams.get('utm_source');

		if (subscriptionList.length && utmSource !== 'coop') {
			const subscriptionHolder = subscriptionList[0];
			const subscriptionDependent = subscriptionList.slice();

			subscriptionDependent.splice(0, 1);

			listFamily = (
				<>
					<BoxSize className='titular-dependente'>
						<TitleListSubscribers>
							<h3>Titular</h3>
						</TitleListSubscribers>
						<ListSubscribers>
							<li key={subscriptionHolder.cpf}>
								<div>
									<span>
										{(' ', ' ', subscriptionHolder.cpf)} |{' '}
										{subscriptionHolder.name}
									</span>
								</div>
								<button
									onClick={() => this.handleStartEdit(subscriptionHolder, 0)}
									type='button'>
									<FaRegEdit size={18} className='FaRegEdit' />
								</button>
							</li>
						</ListSubscribers>

						<TitleListSubscribers>
							{signatureChosen.number_of_dependents > 0 ||
							cmDrConsulta.number_of_dependents > 0 ||
							levelled.number_of_dependents > 0 ? (
								<h3>
									Dependentes {subscriptionDependent.length}/
									{signatureChosen.number_of_dependents ||
										cmDrConsulta.number_of_dependents ||
										levelled.number_of_dependents}
								</h3>
							) : (
								''
							)}
						</TitleListSubscribers>

						<ListSubscribers>
							{subscriptionDependent.map(subscription => (
								<li key={subscription.cpf}>
									<div>
										<span>
											{' '}
											{(' ', ' ', subscription.cpf)} | {subscription.name}
										</span>
									</div>
									{!this.state.isEdit && (
										<button
											onClick={() => this.handleStartRemove(subscription)}
											type='button'>
											<FaTrashAlt size={17} className='FaTrashAlt' />{' '}
										</button>
									)}
									<button
										onClick={() => this.handleStartEdit(subscription)}
										type='button'>
										<FaRegEdit size={18} className='FaRegEdit' />
									</button>
								</li>
							))}
						</ListSubscribers>
					</BoxSize>
				</>
			);
		}
		const planType = campaignUtils.getPlanType(this.props.location.search);
		const pathArray = window.location.pathname.split('/');
		const holder = subscriptionList[0];
		return (
			<ThemeProvider theme={ThemeSelector(pathArray[2])}>
				<Container
					count={subscriptionList.length}
					showForm={this.state.showForm}
					isEdit={this.state.isEdit}
					position={this.state.editData?.position}
					dependentIsActive={dependentIsActive}>
					<Header {...this.props} />
					<FormWrapper>
						<BoxSize>
							<StepCounter
								ass={'not-empty'}
								assinatura={false}
								assinante={true}
								pagamento={false}
								endereco={false}
							/>
						</BoxSize>
						<div>
							{subscriptionList.length > 0 && dependentIsActive == true ? (
								<div>{listFamily}</div>
							) : (
								subscriptionList.length > 0 &&
								loja != 'epay' &&
								loja != 'vivoavulso' &&
								loja != 'levelled' &&
								new URLSearchParams(window.location.search).get('utm_source') !== 'coop' &&
								(
									<>
										<BoxSize className='titular-dependente'>
											<TitleListSubscribers>
												<h3>Lista de assinantes</h3>
											</TitleListSubscribers>

											<ListSubscribers>
												{subscriptionList.map((subscription, key) => (
													<li key={subscription.cpf}>
														<div>
															<span>
																{' '}
																{(' ', ' ', subscription.cpf)} |{' '}
																{subscription.name}
															</span>
														</div>
														{!this.state.isEdit && (
															<button
																onClick={() =>
																	this.handleStartRemove(subscription)
																}
																type='button'>
																<FaTrashAlt size={17} className='FaTrashAlt' />{' '}
															</button>
														)}
														<button
															onClick={() => {
																this.handleStartEdit(subscription, key);
															}}
															type='button'>
															<FaRegEdit size={18} className='FaRegEdit' />
														</button>
													</li>
												))}
											</ListSubscribers>
										</BoxSize>
									</>
								)
							)}

							{this.state.showForm || dependentIsActive == false ? (
								<FormBeneficiario
									initialData={editFormData}
									subscriptionList={subscriptionList}
									onData={this.formData}
									isEdit={this.state.isEdit}
									error={this.state.error}
									cleanForm={this.state.cleanForm}
									errorOnField={this.state.errorOnField}
									errorAccept={this.errorAccept}
									isCompleted={this.handleIsComplete}
									fieldsTouched={this.fieldsTouched}
									position={this.state.position}
									{...this.props}></FormBeneficiario>
							) : (
								<div style={{ padding: '0px' }}></div>
							)}
						</div>

						<BoxSize>
							<div className=''>
								{removeConfirmation}
								{isIncompleteConfirmation}
								{moveForwardWithoutDependents}
								{advanceWithoutSubscribers}
								{/*
								/ Condições da função avançar abaixo:
								/ 1ª Se o usuário está editando NÃO mostrar o avançar.
								/ 2ª Se a loja for familia e o titular não foi adicionado, pergunta
								 se quer adicionar dependente.
								/ 3ª Se a loja for familia e a familia estiver cheia, avança pra
								 proxima pagina ao clicar
								/ 4ª Verifica se os campos estão completos de forma invertida,
								caso  a condição seja verdadeira desabilita o	botão avançar
								/ 5ª Verifica se está processando a requisição de adicionar um
								usuário, caso sim é exibida uma animação de carregando até o fim
								 da requisição...
								/ 6ª Se todas as condições anteriores forem falsas ele avança a
								 pagina e adiciona um usuário caso os campos estejam preenchidos
								  corretamente

							*/}

								{this.state.isEdit ? (
									<div style={{ height: '0px' }}></div>
								) : this.state.isLoading ? (
									<FormButton className='loading-beneficiario'>
										<LoadingB type='spin' color='gray' size={25} />
										<span>Carregando...</span>
									</FormButton>
								) : (dependentIsActive == true &&
										subscriptionList.length <=
											Number(signatureChosen.number_of_dependents)) ||
								  (dependentIsActive == true &&
										subscriptionList.length <=
											Number(cmDrConsulta.number_of_dependents)) ||
								  (dependentIsActive == true &&
										subscriptionList.length <=
											Number(levelled.number_of_dependents)) ? (
									<NavBtn
										style={'btn-goForward-gray'}
										disabled={!this.state.isComplete}
										goForward={this.continueWithoutDependent}
										goForwardText={'PRÓXIMO PASSO'}
										step={true}
									/>
								) : (dependentIsActive == true &&
										subscriptionList.length >=
											Number(signatureChosen.number_of_dependents) + 1) ||
								  (dependentIsActive == true &&
										subscriptionList.length >=
											Number(cmDrConsulta.number_of_dependents) + 1) ||
								  (dependentIsActive == true &&
										subscriptionList.length >=
											Number(levelled.number_of_dependents) + 1) ? (
									<NavBtn
										disabled={!this.state.isComplete}
										goForward={this.formSend}
										goForwardText={'PRÓXIMO PASSO'}
										step={true}
									/>
								) : !this.state.isComplete ? (
									<NavBtn
										disabled={!this.state.isComplete}
										goForward={this.handleAdd}
										goForwardText={'PRÓXIMO PASSO'}
										step={true}
									/>
								) : (
									<NavBtn
										disabled={this.state.isLoading}
										goForward={this.addMoreSubscribers}
										goForwardText={'PRÓXIMO PASSO'}
										step={true}
									/>
								)}
								{this.state.isEdit && !this.state.isLoading ? (
									<FormButton style={{ padding: '0px 0px' }}>
										<button
											onClick={this.handleEdit}
											className='button-assinante-mobile'>
											<strong>Salvar assinante</strong>
										</button>
									</FormButton>
								) : this.state.isEdit && this.state.isLoading &&(
									<FormButton className='loading-beneficiario'>
										<LoadingB type='spin' color='gray' size={25} />
										<span>Carregando...</span>
									</FormButton>
								)}
							</div>
							<div className=''>{payerError}</div>
						</BoxSize>
					</FormWrapper>
				</Container>
			</ThemeProvider>
		);
	}
}

const mapStateToProps = actionObject => {
	return actionObject;
};

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			waitSubscription,
			setWaitCampaign,
			getPlanList,
			createOrder,
			addSubscription,
			addPayer,
			newRemoveSubscription,
			newEditSubscription,
			userLogin,
			applyCampaign,
			applyCampaignInfo,
			setUpdateOrder,
			verifySignatureChosen,
			verifyTokenCmDrConsulta
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(Beneficiario);
